<swiper [config]="config">
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let slide of slides">
      <arsultima-slide-subheader
        [id]="slide?.ID"
        [imageUrl]="getImageUrl(slide)"
        [page]="page"
        [copyright]="slide?.copyright"
        [isEditable]="isEditable"
        [isHome]="true"
        height="300px"
      ></arsultima-slide-subheader>
    </div>
  </div>
  <!-- Add Pagination -->
  <div class="swiper-pagination"></div>
</swiper>
